import clsx from 'clsx';
import React from 'react';
import { SpinnerIcon } from '../../icons';

export const ModalFooter = ({
  data,
  disabled,
  type = 'button',
  handleCancelClick,
  handleOkClick,
  className = '',
  saveBtnText,
  isLoading = false,
}) => {
  return (
    <div className={clsx('flex gap-3', className)}>
      <button
        type="button"
        className="btn-secondary text-secondary-button  order-2 lg:order-1"
        onClick={handleCancelClick}
      >
        Κλείσιμο
      </button>
      {type === 'submit' ? (
        <button
          type="submit"
          className="btn-primary text-primary-button flex gap-2 items-center justify-center order-1 lg:order-2"
        >
          {isLoading && <SpinnerIcon />} {saveBtnText ? saveBtnText : 'Υποβολή'}{' '}
          {/* // Διαγραφή */}
        </button>
      ) : (
        <button
          disabled={disabled}
          type={type || 'button'}
          className="btn-primary text-primary-button flex gap-2 items-center justify-center  order-1 lg:order-2"
          onClick={() => handleOkClick(data)}
        >
          {isLoading && <SpinnerIcon />} {saveBtnText ? saveBtnText : 'Υποβολή'}
        </button>
      )}
    </div>
  );
};
